import { RouterGoToEvent } from "src/components/router";
import { CloseViewEvent } from "src/events/close-view";
import { links } from "src/links";

const titles:string[]=[];

export const pushTitle = (title:string) => {
  titles.push(document.title)
  document.title = title;
}

export const setTitle = (title:string) => {
  document.title = title;
}


export const popTitle = () =>{
  const title =titles.pop();
  if(title != undefined){
    document.title = title;
    return title;
  }
  
}

export const isRoutePrefixMatch = (targetRoute:string):boolean => {
  var currentPathSearch = `${window.location.pathname}${window.location.search}`
  return currentPathSearch.startsWith(targetRoute)
}

export const isHashChangeOnly =(request :{pathname:string, search:string, hash:string}) =>{
    var currentLocation =  window.location;
    if(currentLocation.pathname == request.pathname && currentLocation.search == request.search)
    {
      if(request.hash !== currentLocation.hash)
      {
        return true;
      }
    }
    return false;
  }


export const handleCloseViewEvent = (e: CloseViewEvent) => {
  // if there are no more views in the stack, go to home
  if(window.navigation.canGoBack === false) {
    // this assumes that their is a router in place
    window.dispatchEvent(new RouterGoToEvent(links.dashboard.index));
  } else {
    window.navigation.back(); 
  }
 }

 
 